var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoGenerationMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.417 5H3.333c-.92 0-1.666.746-1.666 1.667v6.666c0 .92.746 1.667 1.666 1.667h7.084c.92 0 1.666-.746 1.666-1.667V6.667c0-.92-.746-1.667-1.666-1.667zM18.333 6.667L12.083 10l6.25 3.333V6.667z",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgVideoGenerationMenu;